import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { useQueryClient } from "react-query";
import { ApiRegistrationParticipantForParticipantResponse } from "../../../../shared/types/ApiRegistrationParticipantForParticipantResponse";
import { ApiApplicableRateCardDetails } from "../../../../shared/types/ApiApplicableRateCardDetails";
import { useAuth } from "../../../../shared/context/auth";
import { refreshDashboardData } from "../../context/dashboard/dataloader";
import TicketStatus from "../../../../shared/enums/TicketStatus";
import { useGetApiData, useGetApiDataAsMutate, usePostApiData } from "shared/datalayer";

export function useGetPurchaseTicketForm({
  registrationParticipantId,
  successHandler,
  errorHandler
}: {
  registrationParticipantId?: string;
  successHandler?: (data: ApiRegistrationParticipantForParticipantResponse) => void;
  errorHandler?: () => void;
}) {
  const queryClient = useQueryClient();
  return useGetApiData<ApiRegistrationParticipantForParticipantResponse>(
    MyExpApi.GET_PURCHASE_TICKET_REG_FORM,
    {
      params: { registrationParticipantId: registrationParticipantId }
    },
    {
      enabled: Boolean(registrationParticipantId),
      onSuccess: data => {
        successHandler?.(data);
      },
      onError: error => {
        errorHandler?.();
        if (error?.response?.data?.refreshPage) {
          refreshDashboardData(queryClient, registrationParticipantId);
        }
      }
    }
  );
}

export function useValidateCouponCode() {
  return useGetApiDataAsMutate<ApiApplicableRateCardDetails>(MyExpApi.VALIDATE_COUPON_CODE);
}

export function useInitiatePurchaseTicket() {
  const queryClient = useQueryClient();
  const auth = useAuth();
  return usePostApiData<ApiRegistrationParticipantForParticipantResponse>(MyExpApi.INITIATE_PURCHASE_TICKET, {
    onSuccess: data => {
      if (data.ticketStatus !== TicketStatus.COMPLETED) {
        refreshDashboardData(queryClient, auth.userDetail?.id);
      }
    }
  });
}
